import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["product"]

  toggleIncompatibleProducts(event) {
    const selectedProduct = event.target
    const productSlug = selectedProduct.dataset.productSlug
    const incompatibleProductSlugs = selectedProduct.dataset.incompatibleProducts.split(",")

    this.productTargets.forEach(product => {
      const productSlug = product.dataset.productSlug

      if (incompatibleProductSlugs.includes(productSlug)) {
        // Disable incompatible products
        product.checked = false;
      }
    })
  }
}
